const o=o=>t=>1-o(1-t);export{o as reverseEasing};
